import { NumberFormatProps } from 'react-number-format';
import { DocTypeEnum } from './types';

export const DEFAULT_LEAD_FORM_VALUES = {
  name: '',
  legalName: '',
  docType: DocTypeEnum.CNPJ,
  docNumber: '',
  volume: undefined,
  responsibleManager: undefined,
  type: undefined,
  origination: undefined,
  projectedRevenue: undefined,
  monthSigningManagementContract: '',
  notes: undefined,
};

export const VOLUME_FORMAT_PROPS: NumberFormatProps = {
  placeholder: 'MWm',
  mask: '_',
  allowNegative: false,
  decimalScale: 3,
  suffix: ' MWm',
  isNumericString: true,
  thousandSeparator: '.',
  decimalSeparator: ',',
};

export const DATE_FORMAT_PROPS = {
  placeholder: 'MM/AAAA',
  format: '##/####',
  mask: '_',
  allowNegative: false,
  decimalScale: 0,
};

export const CPF_LENGTH = 11;
export const CNPJ_LENGTH = 14;
